import gql from 'graphql-tag';

// NOTE: must change name of feature flag created from launch darkly in query layer and interface
export interface ChimeraMeResult {
  chimera: {
    me: {
      featureFlags: {
        'enrollments-ug-enable-county-field': boolean;
      };
    };
  };
}

export const getChimeraFeatureFlags = gql`
  query getUserInformation {
    chimera {
      me {
        featureFlags(names: ["enrollments-ug-enable-county-field"])
      }
    }
  }
`;
